import React, { useState } from 'react'
import Card from 'react-bootstrap/Card'

import NewUserForm, { NewUserFormFields } from 'js/components/forms/NewUserForm'

import { CreateRegisterUserResponse, Organization, OrganizationCode } from 'js/models'
import { FormFeedback } from 'js/services/api'
import { createRegisterUser } from 'js/services/user'
import { getDataFromForm } from 'js/utils/helpers'

import { StepContentProps, Steps } from '.'

interface RSProps extends StepContentProps {
  storeToken: (token: string) => void
  previousStep: Steps
  organizationCode: OrganizationCode | undefined
  organizationData?: Partial<Organization>
}

interface FormData {
  name: string
  email: string
  password1: string
  password2: string
}

export default function RegistrationStart(props: RSProps): React.ReactElement {
  const [errors, setErrors] = useState({} as FormFeedback<NewUserFormFields>)
  const [isLoading, setIsLoading] = useState(false)

  const resetFormFeedback = (): void =>
    setErrors({} as FormFeedback<NewUserFormFields>)

  const onSubmit = (e: React.FormEvent): void => {
    e.preventDefault()
    resetFormFeedback()
    setIsLoading(true)

    const formData: FormData = getDataFromForm(
      e.target,
      ['name', 'email', 'password1', 'password2'],
      'newUserForm_'
    )
    createRegisterUser({
      ...formData,
      organizationCode: props.organizationCode,
      organization: props.organizationData,
    })
      .then(r => {
        props.storeToken((r as CreateRegisterUserResponse).access)
        props.setStep(Steps.ShareJoinCode)
      })
      .catch(e => setErrors(e.formErrors))
      .finally(() => setIsLoading(false))
  }
  return (
    <Card className='unauth-card'>
      <Card.Header>Personal Information</Card.Header>
      <Card.Body>
        <NewUserForm
          onSubmit={onSubmit}
          onBack={(): void => props.setStep(props.previousStep)}
          errors={errors}
          isLoading={isLoading}
        />
      </Card.Body>
    </Card>
  )
}
